import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import './HamburgerMenu.css';

interface HamburgerMenuProps {
  onLogout: () => void;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ onLogout }) => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleLogout = () => {
    closeMenu();
    onLogout();
  };

  return (
    <div className="hamburger-menu">
      <button
        className={`hamburger-button ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {isOpen && (
        <div className="menu-overlay" onClick={closeMenu}></div>
      )}

      <div className={`menu-panel ${isOpen ? 'open' : ''}`}>
        <div className="menu-header">
          <h3>{t('menu.settings')}</h3>
          <button className="close-button" onClick={closeMenu}>
            ×
          </button>
        </div>
        
        <div className="menu-content">
          <div className="menu-item">
            <label>{t('menu.language')}</label>
            <LanguageSwitcher />
          </div>
          
          <div className="menu-divider"></div>
          
          <button className="menu-logout-btn" onClick={handleLogout}>
            {t('nav.logout')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HamburgerMenu;